import { RAIL_STAGES } from '@/lib/selection-phase';

/** Horizontal stepper showing where the selection is in the pipeline. */
export function ProgressRail({ stage }: { stage: number }) {
  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
      {RAIL_STAGES.map((label, i) => {
        const done = i < stage;
        const current = i === stage;
        return (
          <div key={label} className="flex items-center gap-2">
            <span
              className={
                current
                  ? 'rounded-full bg-primary px-3 py-1 font-medium text-primary-foreground'
                  : done
                    ? 'rounded-full bg-primary/15 px-3 py-1 text-primary'
                    : 'rounded-full border px-3 py-1 text-muted-foreground'
              }
            >
              {done ? '✓ ' : ''}
              {label}
            </span>
            {i < RAIL_STAGES.length - 1 && <span className="text-muted-foreground">→</span>}
          </div>
        );
      })}
    </div>
  );
}
